import React from 'react'
import {Box} from '@mui/material'

import {FONT_SIZE, FONT_WEIGHT} from '@/shared/constants/globalStyle'
import {Icon, LinkText} from '@/components/atoms'
import PropTypes from 'prop-types'
import './_linkTextWithIcon.scss'
/**
 * LinkTextWithIcon component renders a text link with an optional icon.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.id - The id for the link text.
 * @param {string} props.text - The text to display in the link.
 * @param {string} [props.fontSize=FONT_SIZE.SM] - The font size of the text.
 * @param {function} props.handleClick - The click handler function for the link.
 * @param {string} [props.iconName='open_in_new'] - The name of the icon to display.
 * @param {string} [props.iconSize='small'] - The size of the icon.
 * @param {boolean} [props.isIconVisible=false] - Flag to determine if the icon should be visible.
 *
 * @returns {JSX.Element} The rendered LinkTextWithIcon component.
 */
const LinkTextWithIcon = ({
  id,
  text,
  fontSize = FONT_SIZE.SM,
  handleClick,
  iconName = 'open_in_new',
  iconSize = 'small',
  isIconVisible = false,
}) => {
  return (
    <Box className={`flex items-center `}>
      <LinkText
        isPaddingHidden={true}
        onClick={handleClick}
        text={text}
        fontWeight={FONT_WEIGHT.BOLD}
        fontColor={'var(--color-interaction-primary)'}
        id={id}
        fontSize={fontSize}
      />
      {isIconVisible && <Icon className={`ltwi-icon-color pl-1`} icon={iconName} size={iconSize} />}
    </Box>
  )
}

LinkTextWithIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.string,
  handleClick: PropTypes.func,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  isIconVisible: PropTypes.bool,
}

export default LinkTextWithIcon
